import { Picker } from "./Picker";
import { useWorkspace } from "../../store/WorkspaceContext";

export const ROLL_LENGTHS = [[300, "25 ft"], [600, "50 ft"], [900, "75 ft"], [1200, "100 ft"], [1800, "150 ft"]];


// Roll length preset — the statusbar shows how much film is left.
export const RollTools = () => {
  const { state, dispatch } = useWorkspace();
  const setLength = (len) => { localStorage.setItem("xpattern.rollLength", String(len)); dispatch({ type: "SET", patch: { rollLength: len } }); };
  return (
    <Picker id="roll-length-select" title="Length of the film roll you loaded — the readout shows what's left" value={state.rollLength} onChange={setLength} className="!w-[112px] flex-none" width={170} options={ROLL_LENGTHS.map(([len, l]) => ({ value: len, label: `Roll ${l}` }))} />
  );
};
